import { Tag } from '@/shared/model/tag.model';
import DataService from '@/core/base/service/data.service';

export default class SponsorTagService extends DataService<Tag> {
    baseApiUrl = 'api/sponsor-tags';
}
